import styled from "@emotion/styled/macro"
import tw from "twin.macro"

export const styles = {
  layout: {
    primary: tw`shadow-button text-18 px-1-2 md:px-2-4 py-1 rounded-0-8 font-label tracking-ease leading-1 uppercase`, // tracking-relaxed
    secondary: tw`border border-dark  text-14 px-1-4 md:text-18 md:px-2 rounded-0-8 py-0-5 md:py-1 font-display tracking-loosest leading-1 uppercase`, // tracking-relaxed
    navigation: tw`shadow-button text-14 px-2 h-4 md:text-16 md:px-2 md:h-4 rounded-0-8 font-display tracking-widest leading-1 uppercase`, // tracking-wider
    circle: tw`border border-dark h-3-6 w-3-6 md:h-4 md:w-4 rounded-full font-display`,
    icon: tw`shadow-button text-14 px-1 w-4 h-4 md:text-20 md:h-4 md:w-4 rounded-0-8 font-label tracking-relaxed leading-1`,
    tertiary: tw`hover:bg-ivory text-14 px-1 py-0-5 outline-none md:text-18 md:px-1 md:py-0-5 rounded-0-8 font-body tracking-ease leading-1 `, // tracking-relaxed
    cartButton: tw`shadow-button p-1 rounded-1`,
    tight: tw`shadow-button text-14 px-1 py-0-8 md:text-18 md:px-1-2 rounded-1 font-label tracking-relaxed leading-1`,
  },
  // layout: {
  //   primary: tw`border border-dark text-14 px-1-2 md:px-2 py-0-8 rounded-0-8 font-body tracking-ease leading-1`, // tracking-relaxed
  //   secondary: tw`shadow-button text-14 px-2 md:text-18 md:px-2 rounded-0-8 py-1-2 md:py-1 font-label tracking-loosest leading-1 uppercase`, // tracking-relaxed
  //   navigation: tw`shadow-button text-14 px-2 h-4 md:text-16 md:px-2 md:h-4 rounded-0-8 font-display tracking-widest leading-1 uppercase`, // tracking-wider
  //   circle: tw`border border-dark h-3-6 w-3-6 md:h-4 md:w-4 rounded-full font-display`,
  //   icon: tw`shadow-button text-14 px-1 w-4 h-4 md:text-20 md:h-4 md:w-4 rounded-0-8 font-label tracking-relaxed leading-1`,
  //   tertiary: tw`border border-transparent hover:border-dark text-14 px-1-2 py-0-4 md:text-20 md:px-2 md:py-0-6 rounded-0-8 font-body tracking-ease leading-1 `, // tracking-relaxed
  //   cartButton: tw`shadow-button p-1 rounded-1`,
  //   tight: tw`shadow-button text-14 px-1 py-0-8 md:text-18 md:px-1-2 rounded-1 font-label tracking-relaxed leading-1`,
  // },

  color: {
    red: tw`text-red`,
    white: tw`text-lightest`,
    transparent: tw`text-transparent`,
    punch: tw`text-punch`,
    lightest: tw`text-dark`,
    light: tw`text-light`,
    beige: tw`text-beige`,
    dark: tw`text-dark`,
    yellow: tw`text-yellow`,
    pink: tw`text-pink`,
    blue: tw`text-blue`,
    burnt: tw`text-burnt`,
    cherrywood: tw`text-cherrywood`,
    grey: tw`text-grey`,
    black: tw`text-dark`,
    offwhite: tw`text-offwhite`,
  },
  bg: {
    red: tw`bg-red`,
    white: tw`bg-lightest`,
    transparent: tw`bg-transparent`,
    punch: tw`bg-punch`,
    lightest: tw`bg-lightest`,
    light: tw`bg-light`,
    beige: tw`bg-beige`,
    dark: tw`bg-dark`,
    yellow: tw`bg-yellow`,
    pink: tw`bg-pink`,
    blue: tw`bg-blue`,
    burnt: tw`bg-burnt`,
    cherrywood: tw`bg-cherrywood`,
    grey: tw`bg-grey`,
    primarynatural: tw`bg-primarynatural`,
    offwhite: tw`bg-offwhite`,
  },
  colour: {
    red: tw`text-red`,
    // transparent: tw`bg-transparent text-dark hover:bg-dark hover:text-lightest active:bg-dark active:text-lightest`,
    punch: tw`hover:bg-punch hover:text-dark active:bg-punch active:text-dark`,
    lightest: tw`hover:bg-lightest hover:text-dark active:bg-lightest active:text-dark`,
    light: tw`hover:bg-light hover:text-dark active:bg-light active:text-dark`,
    beige: tw`hover:bg-beige hover:text-dark active:bg-beige active:text-dark`,
    dark: tw`hover:bg-dark hover:text-lightest active:bg-dark active:text-lightest`,
    yellow: tw`hover:bg-yellow hover:text-dark active:bg-yellow active:text-dark`,
    pink: tw`hover:bg-pink hover:text-dark active:bg-pink active:text-dark`,
    blue: tw`hover:bg-blue hover:text-dark active:bg-blue active:text-dark`,
    burnt: tw`hover:bg-burnt hover:text-lightest active:bg-burnt active:text-lightest`,
    cherrywood: tw`hover:bg-cherrywood hover:text-lightest active:bg-cherrywood active:text-lightest`,
    grey: tw`hover:bg-grey hover:text-dark active:bg-grey active:text-dark`,
    black: tw`hover:text-dark focus:text-dark active:text-dark`,
    transparent: tw`bg-transparent text-dark hover:bg-ivory hover:text-dark active:bg-dark active:text-lightest`,
  },
  background: {
    red: tw`bg-red`,
    transparent: tw`bg-transparent text-dark`,
    punch: tw`bg-punch text-dark`,
    lightest: tw`bg-lightest text-dark`,
    light: tw`bg-light text-dark`,
    beige: tw`bg-beige text-dark`,
    dark: tw`bg-dark text-lightest`,
    yellow: tw`bg-yellow text-dark`,
    pink: tw`bg-pink text-dark`,
    blue: tw`bg-blue text-dark`,
    burnt: tw`bg-burnt text-lightest`,
    cherrywood: tw`bg-cherrywood text-lightest`,
    grey: tw`bg-grey text-dark`,
    primarynatural: tw`bg-primarynatural text-dark`,
    offwhite: tw`bg-offwhite text-dark`,
    ivory: tw`bg-ivory text-dark`,
  },
  circle: tw`rounded-full`,
  disabled: tw`opacity-75 cursor-not-allowed pointer-events-none`,
  noBorder: tw`border-transparent hover:border-transparent active:border-transparent`,
  textSize: {
    sm: tw`text-12 md:text-14`,
    "14": tw`text-14`,
    default: tw`text-16 md:text-20`,
    "18": tw`text-14 sm:text-18`,
    "20": tw`text-14 md:text-20`,
    "26": tw`text-18 md:text-20 lg:text-26`,
    lg: tw`text-24 lg:text-26`,
    "lg-tight": tw`text-24 lg:text-26 leading-0`,
    "sm-tight": tw`text-12 md:text-26`,
    md: tw`text-14 md:text-18`,
    "primary-md": tw`text-18 md:text-26`,
  },
  height: {
    auto: tw`h-auto md:h-auto`,
    "32": tw`h-3-2 md:h-3-2`,
    "40": tw`h-4 md:h-4`,
  },
  showOnHover: tw`opacity-0 group-hover:opacity-100 hover:opacity-100`,
  hovercolor: {
    red: tw`hover:text-red`,
    transparent: tw`hover:text-lightest`,
    white: tw`hover:text-lightest`,
    punch: tw`hover:text-punch`,
    lightest: tw`hover:text-dark`,
    light: tw`hover:text-light`,
    beige: tw`hover:text-beige`,
    dark: tw`hover:text-dark`,
    yellow: tw`hover:text-yellow`,
    pink: tw`hover:text-pink`,
    blue: tw`hover:text-blue`,
    burnt: tw`hover:text-burnt`,
    cherrywood: tw`hover:text-cherrywood`,
    grey: tw`hover:text-grey`,
    black: tw`hover:text-dark`,
  },
  hoverbg: {
    red: tw`hover:bg-red`,
    transparent: tw`hover:bg-transparent`,
    punch: tw`hover:bg-punch`,
    lightest: tw`hover:bg-lightest`,
    light: tw`hover:bg-light`,
    white: tw`hover:bg-lightest`,
    dark: tw`hover:bg-dark`,
    yellow: tw`hover:bg-yellow`,
    pink: tw`hover:bg-pink`,
    blue: tw`hover:bg-blue`,
    burnt: tw`hover:bg-burnt`,
    cherrywood: tw`hover:bg-cherrywood`,
    grey: tw`hover:bg-grey`,
    ivory: tw`hover:bg-ivory`,
  },
}

export const StyledButton = styled.button<StyledButtonProps>`
  ${tw`text-center appearance-none select-none focus:outline-none transition-all duration-slow cursor-pointer`}
  ${({ layout }) => (layout ? styles.layout[layout] : null)}
  ${({ disabled }) => (disabled ? styles.disabled : null)}
  ${({ colour }) => (colour ? styles.colour[colour] : null)}
  ${({ background }) => (background ? styles.background[background] : null)}
  ${({ color }) => (color ? styles.color[color] : null)}
  ${({ bg }) => (bg ? styles.bg[bg] : null)}
  ${({ height }) => (height ? styles.height[height] : null)}
  ${({ textsize }) => (textsize ? styles.textSize[textsize] : styles.textSize.default)}
  ${({ noBorder }) => (noBorder ? styles.noBorder : null)}
  ${({ circle }) => (circle ? styles.circle : null)}
  ${({ hover }) => (hover === "true" ? styles.showOnHover : null)}
  ${({ onhover }) => (onhover ? styles.hovercolor[onhover[0]] : null)}
  ${({ onhover }) => (onhover ? styles.hoverbg[onhover[1]] : null)}
  & {
    ${({ active }) =>
      active && active !== "false"
        ? `svg, img {
            -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
            filter: invert(100%);
          }`
        : ``}
  }
`

type StyledButtonProps = {
  layout?: "primary" | "secondary" | "navigation" | "circle" | "icon" | "tertiary" | "cartButton" | "tight"
  disabled?: boolean
  colour?:
    | "red"
    | "transparent"
    | "punch"
    | "lightest"
    | "light"
    | "beige"
    | "dark"
    | "yellow"
    | "pink"
    | "blue"
    | "burnt"
    | "cherrywood"
    | "grey"
    | "black"
    | "primarynatural"
    | "offwhite"
    | "ivory"

  background?:
    | "red"
    | "transparent"
    | "punch"
    | "lightest"
    | "light"
    | "beige"
    | "dark"
    | "yellow"
    | "pink"
    | "blue"
    | "burnt"
    | "cherrywood"
    | "grey"
    | "primarynatural"
    | "offwhite"
    | "ivory"

  color?:
    | "white"
    | "red"
    | "transparent"
    | "punch"
    | "lightest"
    | "light"
    | "beige"
    | "dark"
    | "yellow"
    | "pink"
    | "blue"
    | "burnt"
    | "cherrywood"
    | "grey"
    | "black"
    | "primarynatural"
    | "offwhite"
    | "ivory"

  bg?:
    | "white"
    | "red"
    | "transparent"
    | "punch"
    | "lightest"
    | "light"
    | "beige"
    | "dark"
    | "yellow"
    | "pink"
    | "blue"
    | "burnt"
    | "cherrywood"
    | "grey"
    | "primarynatural"
    | "offwhite"
    | "ivory"
  height?: "auto" | "32" | "40"
  textsize?: "default" | "sm" | "sm-tight" | "lg" | "lg-tight" | "14" | "18" | "20" | "26" | "md" | "primary-md"
  noBorder?: boolean
  circle?: boolean
  onhover?: any
  hover?: "true" | "false"
  active?: boolean | "true" | "false"
  as?: any
  to?: string
}
